/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import type { SchoolDistrict, SchoolDistrictLevels, SchoolLevelsWidget } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  CLEAR_SCHOOL_WIDGET_DATA,
  CLEAR_SCHOOL_WIDGET_SCHOOLS,
  DONE_FETCHING_SCHOOL_WIDGET_DATA,
  DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS,
  ERROR_FETCHING_SCHOOL_WIDGET_DATA,
  ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS,
  SELECT_DISTRICT,
  SELECT_SCHOOL_LEVEL,
  SET_SCHOOL_WIDGET_DATA,
  SET_SCHOOL_WIDGET_SCHOOLS,
  START_FETCHING_SCHOOL_WIDGET_DATA,
  START_FETCHING_SCHOOL_WIDGET_SCHOOLS,
} from '../constants'

// fetching
export const doneFetchingSchoolWidgetData = createAction(DONE_FETCHING_SCHOOL_WIDGET_DATA)
export const errorFetchingSchoolWidgetData = createAction<
  string,
  typeof ERROR_FETCHING_SCHOOL_WIDGET_DATA
>(ERROR_FETCHING_SCHOOL_WIDGET_DATA)
export const startFetchingSchoolWidgetData = createAction(START_FETCHING_SCHOOL_WIDGET_DATA)
export const doneFetchingSchoolWidgetSchools = createAction(DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS)
export const errorFetchingSchoolWidgetSchools = createAction<
  string,
  typeof ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS
>(ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS)
export const startFetchingSchoolWidgetSchools = createAction(START_FETCHING_SCHOOL_WIDGET_SCHOOLS)

// storing
export const clearSchoolWidgetData = createAction(CLEAR_SCHOOL_WIDGET_DATA)
export const clearSchoolWidgetSchools = createAction(CLEAR_SCHOOL_WIDGET_SCHOOLS)
export const setSchoolWidgetData = createAction<SchoolDistrict, typeof SET_SCHOOL_WIDGET_DATA>(
  SET_SCHOOL_WIDGET_DATA
)
export const setSchoolWidgetSchoolsData = createAction<
  SchoolDistrictLevels,
  typeof SET_SCHOOL_WIDGET_SCHOOLS
>(SET_SCHOOL_WIDGET_SCHOOLS)
export const setSelectedDistrictId = createAction<string, typeof SELECT_DISTRICT>(SELECT_DISTRICT)
export const setSelectedSchoolLevel = createAction<
  SchoolLevelsWidget | null,
  typeof SELECT_SCHOOL_LEVEL
>(SELECT_SCHOOL_LEVEL)
